export function buildAddressPayload(form, user) {
  const { address, address2, city, state, zip, country, phone, email, firstName, lastName } = form;
  return {
    Address1: address.trim(),
    Address2: address2?.trim() || "",
    City: city.trim(),
    State: state.trim(),
    ZipCode: zip.trim(),
    Country: country?.trim() || "US",
    FullName: `${firstName} ${lastName}`.trim() || user?.email,
    phoneNumber: phone?.trim() || user?.phoneNumber || "",
    email: email || user?.email,
  };
}

export function mapAddressRecord(record) {
  if (!record) return null;
  return {
    address: record.Address1 || record.street_address || "",
    address2: record.Address2 || "",
    city: record.City || record.city || "",
    state: record.State || record.state || "",
    zip: record.ZipCode != null ? String(record.ZipCode) : record.postal_code || "",
    country: record.Country || record.country || "US",
    id: record._id,
  };
}

export function savedAddressToCheckoutFields(saved) {
  if (!saved) return null;
  return {
    email: saved.email || "",
    fname: saved.firstName || saved.fname || "",
    lname: saved.lastName || saved.lname || "",
    phoneNumber: saved.phoneNumber || "",
    address: saved.address || "",
    country: saved.country || "",
    city: saved.city || "",
    state: saved.state || "",
    zip: saved.zip != null ? String(saved.zip) : "",
    address_id: saved.address_id || "",
  };
}

export function profileToCheckoutFields(user, addressRecord) {
  const mapped = mapAddressRecord(addressRecord);
  return {
    email: user?.email || "",
    fname: user?.firstName || "",
    lname: user?.lastName || "",
    phoneNumber: user?.phoneNumber || "",
    address: mapped?.address || "",
    country: mapped?.country || "",
    city: mapped?.city || "",
    state: mapped?.state || "",
    zip: mapped?.zip || "",
    address_id: mapped?.id || "",
  };
}
